<div class="cx-container">
    <div *ngIf="loginForm.hasError('invalidCredentials')"
        class="alert alert-danger d-flex justify-content-center align-items-center p-2 my-3">
        <img src="../../../assets/img/error-circle-100.svg"
             width="32"
             height="32"
             alt="Account Error">
        <p class="text-danger m-0">El usuario o contraseña es incorrecto.</p>
    </div>
    <form class="mt-3" [formGroup]="loginForm">
        <div>
            <p class="x-small-label spaced-label text-uppercase">Teléfono o correo</p>
            <app-auth-input controlName="account" accentColorForIcon="true">
            </app-auth-input>
            <p class="x-small-label spaced-label text-uppercase pt-3">Contraseña</p>
            <mat-form-field class="w-100" floatLabel="never">
                <span matPrefix
                    class="login-input-icon material-symbols-rounded accent-color">
                    lock
                </span>
                <div style="display: flex;">
                    <input
                        [type]="hide ? 'password' : 'text'"
                        id="password"
                        matInput
                        placeholder="Ingresa tu contraseña"
                        autocomplete="current-password"
                        formControlName="password"
                        (keyup.enter)="login()"/>
                    <button mat-icon-button
                            class="bg-transparent"
                            (click)="passwordVisibility()">
                        <span class="material-symbols-rounded accent-color">
                            {{ hide ? 'visibility_off' : 'visibility' }}
                        </span>
                    </button>

                </div>
            </mat-form-field>
            <div *ngIf="loginForm.get('password').hasError('minlength')">
                <div class="d-flex flex-row align-items-center gap-3 p-2">
                    <img src="../../../assets/img/error-circle-100.svg"
                         width="32"
                         height="32"
                         alt="Account Error">
                    <p class="text-danger m-0 py-2">
                        Comprueba que la contraseña contenga al menos 8 caracteres.
                    </p>
                </div>
            </div>
            <div *ngIf="
                    loginForm.get('password').hasError('required')
                    && loginForm.get('password').touched">
                <div class="d-flex flex-row align-items-center gap-3 p-2">
                    <img src="../../../assets/img/error-circle-100.svg"
                         width="32"
                         height="32"
                         alt="Account Error">
                    <p class="text-danger m-0">Ingresa tu contraseña.</p>
                </div>
            </div>
        </div>
        <div class="py-3">
            <button mat-flat-button
                    class="role-action-btn w-100"
                    (click)="login()">
                Entrar
            </button>
        </div>
        <ng-container>
            <div class="d-flex flex-column flex-fill">
                <div class="login-type-title text-uppercase spaced-label x-small-label my-3">
                    Otras formas de acceder
                </div>
                <ng-container>
                    <button mat-flat-button
                        type="button"
                        class="btn-login-type-no-accent card-theme-color card-theme-border-color goggl-btn mb-2"
                        (click)="signInWithGoogle()">
                            <img class="me-2" src="./../../assets/img/logos/Google__G__Logo.svg" height="24" alt/>
                            Acceder con Google
                    </button>
                    <button mat-flat-button
                        class="btn-login-type-no-accent card-theme-border-color appl-btn"
                        type="button"
                        (click)="signInWithApple()">
                            <img class="me-2" src="./../../assets/img/logos/apple_logo_120.png" height="24" alt />
                            Acceder con Apple
                    </button>
                </ng-container>
            </div>
            <hr class="app-module-subtitle"/>
        </ng-container>
        <div class="d-flex justify-content-center flex-column">
            <button mat-flat-button
                    class="bg-transparent text-danger"
                    type="button"
                    (click)="requestRecovery()">
                ¿Olvidaste tu contraseña?
            </button>
        </div>
    </form>
</div>
